import React, { useState } from "react";
import styles from "./QuickGuide.module.scss";
import { CloseCircleIcon, CloseIcon } from "../../../assets/icons";

interface QuickGuideProps {
	icon: React.ReactNode;
	title: string;
	description: string;
}

const QuickGuide = ({ icon, title, description }: QuickGuideProps) => {
	const [open, setOpen] = useState(false);

	return (
		<>
			<button type="button" className={styles.trigger} onClick={() => setOpen(true)}>
				{icon}
			</button>

			{open && (
				<div className={styles.overlay} onClick={() => setOpen(false)}>
					<div className={styles.card} onClick={e => e.stopPropagation()}>
						<span className={styles.badge}>Quick Guide</span>
						<h2 className={styles.title}>{title}</h2>
						<p className={styles.description}>{description}</p>
					</div>
					<button type="button" className={styles.closeButton} onClick={() => setOpen(false)}>
						<CloseIcon />
					</button>
				</div>
			)}
		</>
	);
};

export default QuickGuide;
